import { cn } from "@/utils/helpers";
import { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  hover?: boolean;
}

type CardCornerGradientPosition = "top-left" | "bottom-right";

const applyPositionClasses = (position: CardCornerGradientPosition) => {
  return position === "top-left"
    ? "top-0 left-0 rounded-br-4xl"
    : "bottom-0 right-0 rounded-tl-4xl";
};

const CardCornerGradient = ({
  position,
}: {
  position: CardCornerGradientPosition;
}) => (
  <div
    className={cn(
      "absolute w-20 h-20 card-overlay-gradient-hover opacity-0 group-hover:opacity-100 transition-opacity duration-500",
      applyPositionClasses(position)
    )}
  />
);

export const Card = ({
  children,
  hover = true,
  className,
  ...props
}: CardProps) => (
  <div
    className={cn(
      "group glass rounded-4xl shadow-2xl transition-shadow duration-700 z-10 relative overflow-hidden hover:shadow-3xl",
      hover &&
        "cursor-pointer transform transition-[transform,box-shadow] duration-500",
      className
    )}
    {...props}
  >
    <div className="absolute inset-0 z-0 overflow-hidden">
      <div className="absolute inset-0 card-overlay-gradient opacity-40 group-hover:opacity-60 transition-opacity duration-500" />
      <div className="absolute -bottom-20 -left-20 w-48 h-48 rounded-full card-overlay-gradient-hover blur-3xl opacity-30 group-hover:opacity-50 transform group-hover:scale-110 transition-[transform,opacity] duration-700 animate-bounce card-animation-delay-500" />
      <div className="absolute inset-0 card-shine-gradient transform -skew-x-12 translate-x-full group-hover:translate-x-[-200%] transition-transform duration-1000" />
    </div>

    <div className="relative z-10">{children}</div>

    <CardCornerGradient position="top-left" />
    <CardCornerGradient position="bottom-right" />
  </div>
);
